module.exports = __webpack_public_path__ + "media/Death Wish 2000.25fbd3aa.mp3";